import styled, {css, keyframes} from "styled-components";
import {ws} from "styles/tokens";

const redBlinkAnimation = (grow = 1.1) => keyframes`
  0% {
    color: red;
    font-weight: bold;
    font-size: ${grow}rem;
  }
`;

export const StyleLabel = styled.label`
  display: ${(props) => props.display || "block"};
  position: ${(props) => props.position};
  top: ${(props) => props.top};
  margin: ${(props) => props.margin || "0px"};
  margin-top: ${(props) => props.marginTop || "0px"};
  margin-bottom: ${(props) => props.marginBottom || "0px"};
  padding: ${(props) => props.padding || "0px"};
  font-size: ${(props) => props.fontSize || "1.1rem"};
  font-weight: ${(props) => props.fontWeight || "500"};
  font-style: ${(props) => props.fontStyle};
  text-align: ${(props) => props.textAlign};
  text-wrap: ${(props) => props.textWrap};
  color: ${(props) => props.color || ws.fg};
  background-color: ${(props) => props.backgroundColor};
  border-radius: ${(props) => props.borderRadius};
  padding: ${(props) => props.padding};
  cursor: ${(props) => `${props.cursor} !important`};
  word-break: ${(props) => props.wordBreak};
  text-align: ${(props) => props.textAlign};
  position: ${(props) => props.position};
  margin-left: ${(props) => props.marginLeft};
  width: ${(props) => props.width};
  float: ${(props) => props.float};
  animation: ${(props) => {
    const speed = props.fast ? "0.8s" : "2s";
    const grow = props.big ? 1.4 : 1.1;

    return props.redBlink
      ? css`
          ${redBlinkAnimation(grow)} linear ${speed} infinite
        `
      : "none";
  }};
  // If and only if we have an animation, we should put a :after to prevent the label from moving with the animation
  // The size of the :after is props.big ? 1.4 : 1.1
  &::after {
    ${(props) => {
      return (
        props.redBlink &&
        css`
          content: attr(data-text);
          height: 0;
          visibility: hidden;
          overflow: hidden;
          user-select: none;
          pointer-events: none;
          font-size: 1.4rem;
          @media speech {
            display: none;
          }
        `
      );
    }}
  }
`;

export const StyleLabelTitle = styled.label`
  display: ${(props) => props.display || "block"};
  position: ${(props) => props.position};
  top: ${(props) => props.top};
  margin: ${(props) => props.margin || "0px"};
  margin-top: ${(props) => props.marginTop || "0px"};
  margin-bottom: ${(props) => props.marginBottom || "0px"};
  margin-left: ${(props) => props.marginLeft || "0px"};
  padding: ${(props) => props.padding || "0px"};
  font-family: ${ws.fontDisplay};
  font-size: ${(props) => props.fontSize || "1.3rem"};
  font-weight: ${(props) => props.fontWeight || "500"};
  letter-spacing: -0.01em;
  text-align: ${(props) => props.textAlign};
  color: ${(props) => props.color || ws.fg};
  cursor: ${(props) => props.cursor};
  word-break: ${(props) => props.wordBreak};
`;

export const StyleValueLabelRight = styled.label`
  display: ${(props) => props.display || "block"};
  position: "right";
  top: ${(props) => props.top};
  margin: ${(props) => props.margin || "0px"};
  padding: ${(props) => props.padding || "0px"};
  font-size: ${(props) => props.fontSize || "1rem"};
  font-weight: ${(props) => props.fontWeight};
  text-align: "right";
  color: ${(props) => props.color || ws.accentText};
  cursor: ${(props) => props.cursor};
  word-break: ${(props) => props.wordBreak};
`;

export const StyleValueLabel = styled.label`
  display: ${(props) => props.display || "block"};
  position: ${(props) => props.position};
  top: ${(props) => props.top};
  margin: ${(props) => props.margin || "0px"};
  margin-left: ${(props) => props.marginLeft || "0px"};
  margin-bottom: ${(props) => props.marginBottom || "0px"};
  padding: ${(props) => props.padding || "0px"};
  font-size: ${(props) => props.fontSize || "1rem"};
  font-weight: ${(props) => props.fontWeight};
  text-align: ${(props) => props.textAlign};
  color: ${(props) => props.color || ws.fg};
  cursor: ${(props) => props.cursor};
  word-break: ${(props) => props.wordBreak};
  vertical-align: ${(props) => props.verticalAlign};
`;

export const StyleLabelWithSideLine = styled.label`
  display: flex;
  flex-direction: row;
  color: ${ws.muted};
  margin: 30px 0px 30px 0px;
  &:before {
    content: "";
    flex: 1 1;
    border-bottom: 1px solid ${ws.line};
    margin: auto;
    margin-right: 10px;
  }
  &:after {
    content: "";
    flex: 1 1;
    border-bottom: 1px solid ${ws.line};
    margin: auto;
    margin-left: 10px;
  }
`;
